export const DEV = process.env.NODE_ENV === 'development';
const Config =  {
  DEV,
  appName: '生命果培訓工作室 - 活動資訊系統(後台)',
  publicHost: DEV ? 'http://localhost:4000' : 'https://omg.ffl.hk',
  apiHost: DEV ? 'http://localhost/ffl-omg-admin-api/web' : 'https://omg-admin-api.ffl.hk',
  googleClientId : "101986273624-nd107lelj9lpordcptpoin6vh97jpmm5.apps.googleusercontent.com",
};
export default Config;
